import type { IconType } from "@memorang/ui/icon";

export const TTS_PLAY_ICON: IconType = "microphone-message";
